export const useConvertTokenToPDFFormatting = (
  tokenFormatting: ParagraphTokenFormatting | undefined,
  alignment: string,
  lineHeight: number
) => {
  if (!tokenFormatting) return {};

  const size = tokenFormatting?.size ?? 12;
  var shouldStrike = tokenFormatting?.strikeThrough;
  var highlight = useTokenHighlightColor(tokenFormatting?.highlightColor);

  var decorations = [];

  if (tokenFormatting?.underline) {
    decorations.push("underline");
  }

  if (shouldStrike) {
    decorations.push("lineThrough");
  }

  let font = "Tinos";

  if (tokenFormatting?.font?.includes("Times") != true) {
    font = "Lato";
  }

  return {
    fontSize: size,
    color: useRGBToHex(tokenFormatting?.color ?? []),
    bold: tokenFormatting?.bold,
    italics: tokenFormatting?.italic,
    decoration: decorations.length > 0 ? decorations : undefined, // Pass array only if it has values
    background: highlight,
    alignment: alignment,
    font: font,
    lineHeight:
      decorations.includes("underline") || highlight != undefined
        ? 1.0
        : lineHeight,
  };
};
